import React from 'react';
import { arrayOf } from 'prop-types';
import * as LICENCE from 'pgdb-data-layer/lib/Constants/Licence';
import Icon from '../../../../Components/Icon';
import { endorsementType } from '../types';

const EmptyEndorsementsCell = () => {
   return (
      <span className="block-text text-red bold">
         <Icon className="inline-icon" iconName="clear" />
         No Current Endorsements Held
      </span>
   );
};

const EndorsementsCell = ({ endorsements }) => {
   const activeEndorsements = endorsements.filter(e =>
      LICENCE.isCurrentLicenceStatus(e.endorsementStatusCode)
   );

   if (activeEndorsements.length === 0) return <EmptyEndorsementsCell />;

   const endorsementLines = activeEndorsements.map(e => {
      const textColouring =
         e.endorsementStatusCode === LICENCE.LICENCE_STATUS_PENDING
            ? 'orange-text'
            : 'pr-text-active';

      return (
         <div key={e.endorsementId} className="block-text multi-line-cell">
            <span className={`bold ${textColouring}`}>
               <Icon className="inline-icon" iconName="check" />
               {e.endorsementTypeName}
            </span>
         </div>
      );
   });

   return <>{endorsementLines}</>;
};

EndorsementsCell.propTypes = {
   endorsements: arrayOf(endorsementType).isRequired,
};

export default EndorsementsCell;
